import React, { useState, useEffect, FC } from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  TextField,
  CircularProgress,
  Button,
} from '@material-ui/core';
import theme from '../../../theme';

// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectDriversList,
  makeSelectLoading,
} from '../../drivers/selectors';
import { cleanDriverListAction, getDriversAction } from '../../drivers/actions';

import { Autocomplete } from '@material-ui/lab';
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from '@material-ui/pickers';

import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import Icon from '@mdi/react';
import { Controller, useForm } from 'react-hook-form';
import Client from 'client-sdk/src/client';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  mdiCalendar,
  mdiCar,
  mdiClose,
  mdiKeyOutline,
  mdiMapMarkerCheckOutline,
  mdiTruckDeliveryOutline,
} from '@mdi/js';
import { convertPersianDigit2English } from '../../../utils/helpers';
import { Bundle } from '../interfaces';

import { Drivers } from '../../drivers/interfaces';
import { GetAllVehiclesRequestBuilder } from 'client-sdk/src/vehicles/vehicles';
import handleError from '../../../utils/handleError';
import { UpdateBundleRequestBuilder } from 'client-sdk/src/bundles/bundle';
import handleNotfication from '../../../utils/handleNotification';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    inputHolder: {
      flex: 1,
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
  })
);

interface DriverInputs {
  vehicleType: string;
  driverName: string;
  driverId: number | string;
  deliveryDate: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
}

interface Props {
  show: boolean;
  handleCloseEditModal: () => void;
  data: Bundle;
  getDriversDipatch: (payload: object) => void;
  cleanDriverListDispatch: () => void;
  driversLoading: boolean;
  driversList: Drivers[];
}

interface SelectorProps {
  driversLoading: boolean;
  driversList: Drivers[];
}

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });
const Edit: FC<Props> = ({
  show,
  data,
  handleCloseEditModal,
  driversLoading,
  getDriversDipatch,
  driversList,
}: Props): React.ReactElement => {
  const { handleSubmit, errors, setValue, control, getValues } = useForm<
    DriverInputs
  >({
    defaultValues: {
      driverId: data?.driverId,
      driverName: data?.driverName,
      vehicleType: data?.vehicleClass,
      deliveryDate: data?.deliveryDate,
    },
  });
  const token = localStorage.getItem('token') || '';
  const classes = useStyles();
  const [confirmationDialog, setConfirmationDialog] = useState(
    false as boolean
  );

  const [loading, setLoading] = useState(false as boolean);
  const [bundleInfo, setBundleInfo] = useState<DriverInputs | null>(null);

  const handleFormSubmit = (values: DriverInputs) => {
    setBundleInfo(values);
    setConfirmationDialog(true);
  };

  const getVehicles = async (type: string) => {
    try {
      const vehiclesRequest = new GetAllVehiclesRequestBuilder()
        .params({ 'klass.equals': type, size: 1000 })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(vehiclesRequest);
      if (data) {
        getDriversDipatch({ 'vehicleId.in': data.map(el => el.id), size: 1000 });
      }
    } catch (err) {
      handleError(err.response);
    }
  };

  useEffect(() => {
    if (data?.vehicleClass) {
      getVehicles(data.vehicleClass);
    }
    return () => {
      cleanDriverListAction();
    };
  }, []);

  const hanleSubmitEdit = async () => {
    try {
      setLoading(true);
      const payload = {
        sourceName: data.sourceName,
        id: data.id,
        driverId: bundleInfo?.driverId,
        deliveryDate: bundleInfo?.deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          jMoment(bundleInfo?.deliveryStartTime).format('HH:mm:ss')
        ),
        deliveryEndTime: convertPersianDigit2English(
          jMoment(bundleInfo?.deliveryEndTime).format('HH:mm:ss')
        ),
        driverName: bundleInfo?.driverName,
        driverPhoneNumber: driversList.find(
          el => el.id === +bundleInfo.driverId
        )?.phoneNumber,
        orderCount: data.ordersCount,
        priority: data?.priority,
        status: data?.status,
        vehicleClass: bundleInfo?.vehicleType,
        vehicleId: driversList.find(el => el.id === +bundleInfo.driverId)
          ?.vehicleId,
      };

      const editBundleRequest = new UpdateBundleRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(editBundleRequest);
      handleNotfication('مرسوله با موفقیت ویرایش شد', 'success');
      handleCloseEditModal();
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeType = (value: string) => {
    getVehicles(value);
    setValue('driverId', '');
    setValue('driverName', '');
  };

  const handleSelectDriver = (value: string) => {
    setValue('driverName', value);
    const selectedDriverItem = driversList.find(el => el.name === value);
    if (selectedDriverItem) {
      setValue('driverPhone', selectedDriverItem.phoneNumber);
      setValue('driverId', selectedDriverItem.id);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={show}
        fullWidth
        onClose={handleCloseEditModal}
        aria-labelledby="responsive-dialog-title"
      >
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <DialogContent>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              <IconButton aria-label="close" onClick={handleCloseEditModal}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            </div>
            <div className={classes.editIcon}>
              <Icon
                path={mdiTruckDeliveryOutline}
                size={4}
                color={theme.palette.blue.main}
              />
            </div>
            <Grid container spacing={3}>
              <Grid container item xs={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon path={mdiCar} size={1} className={classes.icon} />
                    <InputLabel className={classes.label} id="vehicleType">
                      نوع خودرو
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%', marginBottom: '8px' }}
                      name="vehicleType"
                      control={control}
                      defaultValue={
                        data?.driverVehicleKlass ? data?.driverVehicleKlass : ''
                      }
                      rules={{ required: true }}
                      render={({ onChange, value }) => (
                        <Select
                          value={value}
                          style={{ width: '100%' }}
                          onChange={e => {
                            onChange(e);
                            handleChangeType(e.target.value);
                          }}
                        >
                          <MenuItem value={'CAR'}>سواری</MenuItem>
                          <MenuItem value={'MOTORCYCLE'}>موتورسیکلت</MenuItem>
                          <MenuItem value={'PICKUPS'}>وانت</MenuItem>
                          <MenuItem value={'TRUCK'}>کامیون سبک</MenuItem>
                          <MenuItem value={'HEAVY_TRUCK'}>
                            کامیون سنگین
                          </MenuItem>
                          <MenuItem value={'AIRPLANE'}>هواپیما</MenuItem>
                        </Select>
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.vehicleType && 'نوع خودرو الزامی است'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerCheckOutline}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="driverName">
                      نام راننده
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="driverName"
                      control={control}
                      rules={{ required: true }}
                      render={({ onChange }) => (
                        <Autocomplete
                          id="driverName"
                          noOptionsText="موردی یافت نشد"
                          disableClearable
                          onChange={(event: any, newValue: any | null) => {
                            onChange(event);
                            handleSelectDriver(newValue.name);
                          }}
                          getOptionSelected={(option, value) =>
                            option.name === value.name
                          }
                          getOptionLabel={options => options.name}
                          options={driversList ? driversList : []}
                          loading={driversLoading}
                          loadingText="در حال بارگذاری"
                          renderInput={params => (
                            <TextField
                              {...params}
                              margin="normal"
                              placeholder={data?.driverName}
                              InputProps={{
                                ...params.InputProps,
                                type: 'search',
                                endAdornment: (
                                  <React.Fragment>
                                    {driversLoading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.driverName && 'نام راننده الزامی است'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="driverId">
                      شناسه راننده
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="driverId"
                      control={control}
                      disabled
                      as={<TextField type="text" />}
                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="deliveryDate">
                      تاریخ تحویل
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="deliveryDate"
                      control={control}
                      rules={{ required: true }}
                      disabled
                      render={() => (
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale="fa"
                        >
                          <DatePicker
                            fullWidth
                            autoOk
                            variant="inline"
                            format="YYYY/MM/DD"
                            clearable
                            okLabel="تأیید"
                            disablePast
                            cancelLabel="لغو"
                            clearLabel="پاک کردن"
                            value={getValues().deliveryDate}
                            labelFunc={date =>
                              date?.isValid()
                                ? date.format('jYYYY/jMM/jDD')
                                : ''
                            }
                            onChange={value => {
                              value &&
                                setValue(
                                  'deliveryDate',
                                  convertPersianDigit2English(
                                    value.format('YYYY-MM-DD')
                                  )
                                );
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.deliveryDate && 'تاریخ تحویل الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel
                      className={classes.label}
                      id="deliveryStartTime"
                    >
                      ساعت آغار به کار
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="deliveryStartTime"
                      control={control}
                      rules={{ required: true }}
                      disabled
                      render={() => (
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale="fa"
                        >
                          <TimePicker
                            fullWidth
                            autoOk
                            variant="inline"
                            format="YYYY/MM/DD"
                            clearable
                            ampm={false}
                            okLabel="تأیید"
                            cancelLabel="لغو"
                            clearLabel="پاک کردن"
                            value={getValues().deliveryStartTime}
                            labelFunc={date =>
                              date?.isValid() ? date.format('HH:mm') : ''
                            }
                            onChange={value => {
                              value &&
                                setValue(
                                  'deliveryStartTime',
                                  convertPersianDigit2English(
                                    value.format('jYYYY/jMM/jDD HH:mm')
                                  )
                                );
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.deliveryStartTime &&
                        'ساعت آغاز به‌کار الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={6} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                    <InputLabel className={classes.label} id="deliveryEndTime">
                      ساعت پایان کار
                    </InputLabel>
                  </span>
                  <span className={classes.inputHolder}>
                    <Controller
                      style={{ width: '100%' }}
                      name="deliveryEndTime"
                      control={control}
                      rules={{ required: true }}
                      disabled
                      render={() => (
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale="fa"
                        >
                          <TimePicker
                            fullWidth
                            autoOk
                            variant="inline"
                            format="YYYY/MM/DD"
                            clearable
                            ampm={false}
                            okLabel="تأیید"
                            cancelLabel="لغو"
                            clearLabel="پاک کردن"
                            value={getValues().deliveryEndTime}
                            labelFunc={date =>
                              date?.isValid() ? date.format('HH:mm') : ''
                            }
                            onChange={value => {
                              value &&
                                setValue(
                                  'deliveryEndTime',
                                  convertPersianDigit2English(
                                    value.format('jYYYY/jMM/jDD HH:mm')
                                  )
                                );
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    />
                    <FormHelperText error focused>
                      {errors.deliveryEndTime && 'ساعت پایان کار الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={handleCloseEditModal}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {`خیر`}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={confirmationDialog}
        fullWidth
        onClose={() => setConfirmationDialog(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => setConfirmationDialog(false)}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div>ایا از اختصاص مرسوله به {getValues().driverName} مطمئن هستید؟</div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setConfirmationDialog(false)}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                disabled={loading}
                onClick={hanleSubmitEdit}
                variant="contained"
                size="large"
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driversLoading: makeSelectLoading(),
  driversList: makeSelectDriversList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getDriversDipatch: (payload: object) => dispatch(getDriversAction(payload)),
    cleanDriverListDispatch: () => dispatch(cleanDriverListAction()),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Edit);
